export default "__VITE_ASSET__DCUqg5$B__"